import useStorage from '@/utils/useStorage'
import { setToken } from '@/utils/checkLogin'
import { useRouter } from 'next/router'
import { fbCompleteRegistrationEvent } from '@/utils/fbEvent'

// 登陆后处理缓存
export default function useAfterOnboarding({ rememberPassword }: { rememberPassword?: boolean }) {
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams')
  const router = useRouter()

  function afterRegisterSuccess(params?: Record<string, any>, data?: Record<string, any>) {
    fbCompleteRegistrationEvent()
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params))
    } else {
      removeLoginParams()
    }
    // 记录登录状态
    if (data?.data?.access_token) {
      setToken(data?.data?.access_token)
    }
    // 跳转信息补充页
    const email = params?.email ? '/onboarding?email=' + params?.email : '/onboarding'
    router.push(email)
  }

  function afterPhoneRegisterSuccess(params?: Record<string, any>, data?: Record<string, any>) {
    fbCompleteRegistrationEvent()
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params))
    } else {
      removeLoginParams()
    }
    // 记录登录状态
    if (data?.data?.access_token) {
      setToken(data?.data?.access_token)
    }
    // 跳转信息补充页
    const email = params?.email ? '/onboarding?email=' + params?.email : '/onboarding'
    router.push(email)
  }

  return { loginParams, afterRegisterSuccess, afterPhoneRegisterSuccess }
}
